'use client';
import { useEffect, useRef, useState } from 'react';
import Header from './header';
import useAutoPaginateOrders from '@/hooks/orders/useAutoPaginateOrders';
import NoItems from '@/components/empty/no-items';
import { useTranslations } from 'next-intl';
import { OrderCard } from '@/components/ui/cards';
import { Loading } from '@/components/ui/forms';
import NoOrders from '@/components/ui/icons/no-orders';

function Index({ mage }) {
  const t = useTranslations('user');
  const [selectedPeriod, setSelectedPeriod] = useState('last_3_week');
  const ref = useRef(null);

  const {
    orders,
    loading: orderLoading,
    loadMoreOrders,
    allDataLoaded,
  } = useAutoPaginateOrders({
    pageSize: 10,
    dateFilter: selectedPeriod,
    mage,
    page: 1,
  });

  const handlePeriodChange = (selectedOption) =>
    setSelectedPeriod(selectedOption);

  useEffect(() => {
    loadMoreOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPeriod]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !orderLoading && !allDataLoaded) {
          loadMoreOrders();
        }
      },
      {
        root: null, // viewport
        rootMargin: '0px',
        threshold: 1.0, // Trigger when 100% of the target is visible
      }
    );

    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [orderLoading, allDataLoaded, loadMoreOrders]);
  // orders.items = []
  return (
    <>
      <Header handlePeriodChange={handlePeriodChange} />
      <>
        {!orders?.items?.length && orderLoading == false ? (
          <NoItems
            title={t('no_orders_key')}
            description={t('no_orders_message_key')}
            button={t('shop_now_key')}
            buttonLink='/'
            icon={
              <div className='flex size-[347] items-center justify-center rounded-full bg-[#fcebeb]'>
                <NoOrders className='max-lg:mt-15' />
              </div>
            }
          />
        ) : (
          <>
            {orders?.items.map((order, idx) => (
              <OrderCard key={`user-orders-${idx}`} order={order} />
            ))}
            <div ref={ref} className='flex items-center justify-center' />
          </>
        )}
        {orderLoading && (
          <div className='flex items-center justify-center'>
            <Loading />
          </div>
        )}
      </>
    </>
  );
}

export default Index;
